'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;
exports.reloadCunews = reloadCunews;
exports.loadMoreCunews = loadMoreCunews;
var RELOAD_CU_NEWS = 'bp/cu/news/RELOAD_CU_NEWS';
var RELOAD_CU_NEWS_SUCCESS = 'bp/cu/news/RELOAD_CU_NEWS_SUCCESS';
var RELOAD_CU_NEWS_FAIL = '/cu/news/RELOAD_CU_NEWS_FAIL';

var LOADMORE_CU_NEWS = 'bp/cu/news/LOADMORE_CU_NEWS';
var LOADMORE_CU_NEWS_SUCCESS = 'bp/cu/news/LOADMORE_CU_NEWS_SUCCESS';
var LOADMORE_CU_NEWS_FAIL = 'bp/cu/news/LOADMORE_CU_NEWS_FAIL';

var initialState = {
    news: [],
    pager: {},
    loading: true,
    cuHashId: ""
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case RELOAD_CU_NEWS:
            return _extends({}, state, {
                news: [],
                pager: {},
                loading: true,
                cuHashId: action.cuHashId
            });
        case RELOAD_CU_NEWS_SUCCESS:
            if (!action.result.data.success) {
                return state;
            }
            return _extends({}, state, {
                loading: false,
                news: action.result.data.data,
                pager: action.result.data.pager
            });
        case LOADMORE_CU_NEWS_SUCCESS:
            if (!action.result.data.success) {
                return state;
            }
            return _extends({}, state, {
                news: state.news.concat(action.result.data.data),
                pager: action.result.data.pager
            });
        default:
            return state;
    }
}

function _createQuery(state, cuHashId) {
    var query = {
        page: state.pager ? state.pager.page + 1 : 1,
        size: state.pager && state.pager.size ? state.pager.size : 10,
        schoolHashId: cuHashId
    };
    return query;
}

function _reloadCunews(query) {
    return {
        types: [RELOAD_CU_NEWS, RELOAD_CU_NEWS_SUCCESS, RELOAD_CU_NEWS_FAIL],
        promise: function () {
            function promise(client) {
                return client.post('/api/cu_school/news', query);
            }

            return promise;
        }(),
        cuHashId: query.schoolHashId
    };
}

function reloadCunews(cuHashId) {
    return function (dispatch, getState) {
        var state = getState().cuNews;
        state.pager = null;
        var query = _createQuery(state, cuHashId);
        dispatch(_reloadCunews(query));
    };
}

function _loadMoreCunews(query, callback) {
    return {
        types: [LOADMORE_CU_NEWS, LOADMORE_CU_NEWS_SUCCESS, LOADMORE_CU_NEWS_FAIL],
        promise: function () {
            function promise(client) {
                return client.post('/api/cu_school/news', query);
            }

            return promise;
        }(),
        afterSuccess: function () {
            function afterSuccess(dispatch, getState, response) {
                if (callback) {
                    callback();
                }
            }

            return afterSuccess;
        }()
    };
}

function loadMoreCunews(callback) {
    return function (dispatch, getState) {
        var state = getState().cuNews;
        if (state.pager && state.pager.page && state.pager.page == state.pager.totalPages) {
            return;
        }
        var query = _createQuery(state, state.cuHashId);
        dispatch(_loadMoreCunews(query, callback));
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/reducers/cu/cuNews.js
// module id = 458
// module chunks = 0